module.exports = {
  content: {
    welcome: "Welcome",
    signOut: "Logout",
    or: "or",
    hello: "Hello,",
    please: "Please",
    announcement: "Announcement",
    none: "none",
    applySettle: "Apply To Settle In",
    myOrder: "Order",
    shoppingCart: "Cart",
    checkCarts: "You need to sign in to view",
    checkProducts: "Check account information after login",
    joinCart: "Your cart is currently empty",
    delete: "Remove",
    viewAll: "View Cart",
    mine: "Account",
    typesGoods: "Types of goods",
    sold: "Sold",
    address: "Address",
    collect: "Collect",
    goods: "Goods",
    shop: "Shop",
    search: "Search",
    searchPlaceholder: "Search for the device you want",
  }
}



// WEBPACK FOOTER //
// ./src/assets/lang/en-us/header.js